import { useSelector } from "react-redux";
import { ProductState } from "./product.Slice";

export const useProduct = () => {
  return useSelector(({ product }) => product);
};
